// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import { SmartTable } from '../../../../components/smart-table/smart-table.model';
import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller(
    $scope,
    $state,
    $uibModal,
    Alert,
    DestructiveOperationModal,
    UserPhoneNumber,
) {
    this.$onInit = () => {
                    $scope.userPhoneNumbers = this.phoneNumbers;
                    $scope.st = new SmartTable();
                    $scope.isSmsUser = this.account.roles.includes('ROLE_SMS_USER');

                    $scope.deleteNumber = function(phoneNumber) {
                        $scope.successfulDelete = function() {
                            const key = 'phone_numbers.sms_number.delete_number';
                            const variables = {phoneNumber: phoneNumber.phoneNumber};
                            Alert('success', key, variables);
                            location.reload();
                        };
                        if (phoneNumber.status == "ACTIVE") {
                            const url = `app/rest/phonenumbers/${phoneNumber.id}?status=ACTIVE`;
                            DestructiveOperationModal({
                                titleKey: 'destructive_operation.delete_mobile_number_title',
                                textKey: 'destructive_operation.delete_mobile_number_text',
                                http: {method: 'DELETE', url}
                            }).then(() => {
                                $scope.successfulDelete();
                            });
                        } else {
                            UserPhoneNumber.deletePendingNumber({
                                id : phoneNumber.id
                            }, function() {
                                $scope.successfulDelete();
                            });
                        }
                    }

                    $scope.openVerificationModal = function(phoneNumber) {
                        $uibModal
                            .open({
                                component: 'verifyPhoneNumber',
                                resolve: {phoneNumber: () => phoneNumber},
                            }).result
                            .then(() => $scope.userPhoneNumbers = UserPhoneNumber.query());
                    }

                    $scope.setAsSmsNumber = function(id) {
                        $uibModal.open({
                            templateUrl: require('./sms-number.html'),
                            controller: SmsNumberModalInstanceCtrl,
                            resolve : {
                                id : function() {
                                    return id;
                                }
                            }
                        });
                    };
    };
}

/** @ngInject */
function SmsNumberModalInstanceCtrl(
    $state,
    $scope,
    $uibModalInstance,
    Alert,
    id,
    NewSmsNumber,
    SmsNumber,
    SmsNumberGenerateCode,
) {

    $scope.showFirst = true;
    $scope.showSecond = false;
    $scope.showThird = false;
    $scope.userPhoneId = id;

    $scope.checkPin = function() {
        SmsNumber.save({
            id : $scope.userPhoneId
        }, $scope.pin, function(response) {
            $scope.showFirst = false;
            $scope.showSecond = true;
            $scope.showThird = false;
        }, function(response) {
            $scope.topLevelMessage = new SpAlert('danger', response.data.message);
        })
    }

    $scope.continueSmsNumber = function() {
        SmsNumberGenerateCode.save({
            id : $scope.userPhoneId
        }, $scope.pin, function(response) {
            $scope.showFirst = false;
            $scope.showSecond = false;
            $scope.showThird = true;
        }, function(response) {
            $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            $scope.cancel();
        })
    }

    $scope.setSmsNumber = function() {
        NewSmsNumber.save({
            id : $scope.userPhoneId
        }, $scope.activationCode, function(response) {
            Alert('success', 'phone_numbers.sms_number.messages.change_sms_number');
            $scope.cancel();
            $state.reload('user.mobile-numbers');
        }, function(response) {
            if (response.data.serviceErrorCode.toString() == 'ERR_101403') {
                $scope.cancel();
                $state.reload('user.mobile-numbers');
            } else {
                $scope.topLevelMessage = new SpAlert('danger', response.data.message);
            }
        })
    }

    $scope.cancel = function() {
        $scope.userPhoneId = null;
        $scope.pin = null;
        $scope.activationCode = null;
        $scope.showFirst = false;
        $scope.showSecond = false;
        $scope.showThird = false;
        $uibModalInstance.dismiss('cancel');
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/phone-numbers/list/phone-number-list.controller.js